import { AuthService } from "./_services/auth.service";

export function appInitializer(authService: AuthService) {
    return () => new Promise(resolve => {
        // attempt to refresh token on app start up to auto authenticate
        authService.refreshAccessToken()
            .subscribe(({ access_token }) => authService.setAccessToken(access_token))
            .add(resolve);
    });
}